import React from 'react'
import ReactDOM from 'react-dom'
import * as firebase from 'firebase/app'

import './tailwind.css'

import { Router } from './navigation'
import * as serviceWorker from './serviceWorker'

// const firebaseConfig = {
//   apiKey: "AIzaSyATo3o-aZrwYeSPt09ilNI7GVYv2FqAG-s",
//   authDomain: "knr-rewards-qa.firebaseapp.com",
//   databaseURL: "https://knr-rewards-qa.firebaseio.com",
//   projectId: "knr-rewards-qa",
//   storageBucket: "knr-rewards-qa.appspot.com",
//   messagingSenderId: "884158457865",
//   appId: "1:884158457865:web:81c3b4de058cb488e930d8",
//   measurementId: "G-RSCJJ52RBH"
// }
const firebaseConfig = {
  apiKey: "AIzaSyDPbTqMfT4WHvQUgnylJIZmdCxxGayVb2U",
  authDomain: "knr-rewards.firebaseapp.com",
  databaseURL: "https://knr-rewards.firebaseio.com",
  projectId: "knr-rewards",
  storageBucket: "knr-rewards.appspot.com",
  messagingSenderId: "661751981750",
  appId: "1:661751981750:web:c3d816e2397705aad36817",
  measurementId: "G-EFGYJMQ40P"
}

firebase.initializeApp(firebaseConfig)

ReactDOM.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
